import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const DropdownMenu = styled.ul`
    position: absolute;
    width: 200px;
    border-radius: 3px;
    border: 1px solid ${({ theme }) => theme.borders.preferenceMenuLine};
    background-color: ${({ theme }) => theme.backgrounds.actionDropDown};
    padding: 17px 0;
    z-index:9999;
    box-shadow: ${({ theme }) => theme.shadows.actionDropDown} 0 0 50px 0;
    right: 0px;
    top: 48px;
`;
DropdownMenu.displayName = 'DropdownMenu';

export const UserDropdownItem = styled.li`
    list-style: none;
    text-align: left;
    color: ${({ theme }) => theme.text.actionDropDownItem};
    font-size: 14px;
    padding:10px 20px;
    font-weight: 300;
    cursor: pointer;
    &:hover{
        background-color: ${({ theme }) => theme.backgrounds.actionDropDownHover};
    }

    & a{
        color: ${({ theme }) => theme.text.actionDropDownItem};
    }
`;
UserDropdownItem.displayName = 'DropdownItem';

export const UserAvatar = styled.div`
    position: relative;
    cursor: pointer;
`;
UserDropdownItem.displayName = 'UserAvatar';

export const CustomLink = styled(Link)`
    text-decoration: none !important;
    display:flex;
`;
